module.exports = __webpack_public_path__ + "img/PPT.e8cc4c5f.svg";